<template>
  <div data-css-scope="quasar" :class="bodyClasses">
    <QSlider v-bind="$attrs" ref="qRef" @change="$emit('change')"></QSlider>
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false
}
</script>

<script lang="ts" setup>
import { defineExpose, onMounted, ref } from 'vue';
const qRef = ref();
const bodyClasses = ref();
const possibleClasses = [
  'body--dark',
  'body--light',
  'desktop',
  'mobile',
  'touch',
  'no-touch',
  'platform-android',
  'platform-ios',
  'native-mobile',
  'electron',
  'bex',
  'within-iframe',
];
onMounted(() => {
  const classList = Array.from(document.body.classList);
  bodyClasses.value = classList.filter(value => possibleClasses.includes(value));
});

const exposed = {};
const methods = [
];
methods.forEach((methodName) => {
  const proxyFunction = (...params) => {
    return qRef.value[methodName](...params);
  }
  exposed[methodName] = proxyFunction;
})
defineExpose(exposed)
</script>

<style lang="scss" scoped>
::v-deep(.q-slider) {
  .q-slider__markers {
    background-repeat: repeat;
  }
  .q-slider__text-container {
    display: flex;
    align-items: center;
    min-height: 32px;
  }
  .q-slider__text {
    font-weight: 500;
  }
}
</style>
